//ขอเบิกสินค้า
import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import {
  genURL,
  gengetURLTEST,
  genpostURL,
  genpostURLTEST,
} from "./../_getjson";
import PopUpItem from "./../PopUp/PopUpItem";
import PopupArcode from "./../PopUp/PopUpArcode";
import PopUpOther from "./../PopUp/PopUpOther";
import _PopUpwarehouse from "./../PopUp/PopUpwarehouse";
import PopUpOther1 from "./_PopUpOther";
import { parseJwt } from "../parseJWT";
import { checkunit } from "../_source/checkUnit";
import Checkdocgroup from "./../CustomFunction/Docgroup/Checkdocgroup";
import Chackdocno from "./../CustomFunction/Docno/GetDocno";
import ChackAr from "./../CustomFunction/Csar/GetAr";
import CheckUser from "./../CustomFunction/Csuser/GetUser";
import CheckBrabchname from "./../CustomFunction/Branch/Checkname";
import CheckDepartmentname from "./../CustomFunction/Department/Checkname";
import axios from "axios";
import Backdrop from "./../Components/CustomBackdrop/Barckdrop";
import Snackbar from "./../Components/Snackbar/Snackbar";
import ErrorIcon from "@mui/icons-material/ErrorOutlineRounded";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import AutorenewIcon from "@mui/icons-material/AutorenewRounded";
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers";
import Topbar from "../Components/Customtopbar/Topbar";
import SelectDatas from "./../PopUp/SelectData";
import CustomInputtext from "./../Components/CustomInput/Inputtext";
import "./../_css/App.css";
import FullScreenDialog from "../PopUp/FullScreendialogs/FullScreen";
import Rechecked from "./Components/Rechecked";
import Dateconvertthai from "../CustomFunction/Date/Dateconvert_thai";
import CheckCodeDocGroup from "../CustomFunction/Docgroup/CheckCodeDocGroup";
import { Grid } from "@mui/material";
import PDFReportDialog from "../Components/Reportview/PDFReportDialog";
import { set } from "date-fns";

const listmenu = [["-", "-"]];

// require('../_css/Withdrawalrequest.css');
export default class Withdrawalrequest extends Component {
  constructor(props) {
    super(props);
    this.Issuetype_code = React.createRef();
    this.Groupdata_code = React.createRef();
    this.Groupdata = React.createRef();
    this.DeliNumber = React.createRef();
    this.Issuetype = React.createRef();
    this.withdrawalName = React.createRef();
    this.Csuser_code = React.createRef();
    this.Csuser = React.createRef();
    this.CustomerCode = React.createRef();
    this.CustomerName = React.createRef();
    this.remark = React.createRef();
    this.Department_code = React.createRef();
    this.Department = React.createRef();
    this.Branch_code = React.createRef();
    this.Branch = React.createRef();
    this.state = {
      tableData: [],
      rowtb: "300",
      cellname: "",
      rowClick: "",
      sdefaultwarehousename: "",
      OtPopupType: "",
      sdefaultlocationName: "",
      sduedate: "",
      sEnableedit: false,
      Groupdata_txt: "",
      Issuetype_txt: "",
      Department_txt: "",
      Branch_txt: "",
      openBackdrop: false,
      autoClose: 3600,
      color: "warning",
      messagealert: "",
      checkenableInput: [],
      PROJECT: "",
      defaultvaluewarehouse: "",
      defaultwarehouse: "",
      defaultlocetion: "",
    };
  }

  async componentDidMount() {
    await this.setState({
      checkenableInput: JSON.parse(localStorage.getItem("checkoftxt")),
    });

    let SITECODESTR = parseJwt(localStorage.getItem("Token"));
    this.setState({ siteCodeUser: SITECODESTR.User.SITECODE });
    this.setState({ usercode: SITECODESTR.User.CODE });
    this.onAddValue("Csuser", SITECODESTR.User.CODE);
    this.onAddValue("Branch", SITECODESTR.User.SITECODE);
    this.setRow(this.state.rowtb);

    this.checkMID();
    //this.loadFromInDB(mid)
  }

  checkMID = () => {
    let mid = new URLSearchParams(location.search).get("mid");
    this.setState({ mid: mid });
  };
  _onSave = async () => {
    const parameter = new URLSearchParams();

    parameter.append("CREATEUSER", localStorage.getItem("Username"));
    parameter.append("DOCNO", this.DeliNumber.current.value);
    parameter.append("REMARK", this.remark.current.value);
    parameter.append("ARCODE", this.CustomerCode.current.value);
    parameter.append("ARNAME", this.CustomerName.current.value);
    parameter.append("ISSUETYPE", this.Issuetype_code.current.value);
    parameter.append("DOCGROUP", this.Groupdata_code.current.value);
    parameter.append("DEPARTMENT", this.Department_code.current.value);
    parameter.append("SITECODE", this.Branch_code.current.value);
    parameter.append("COMPUTERNAME", "");
    parameter.append("withdrawaldate", this.state.withdrawaldate);
    parameter.append("scheduledreturn", this.state.scheduledreturn);
    parameter.append("PROJECT", this.state.PROJECT);

    var product = this.state.tableData;
    var productArr = [];
    var s = [];
    for (let index = 0; index < product.length; index++) {
      if (product[index].T_Code !== undefined && product[index].T_Code !== "") {
        productArr[index] = {
          Productcode: product[index].T_Code,
          Productname: product[index].T_List,
          Warehouse: product[index].T_Treasury,
          Location: product[index].T_Location, //3
          Unitcode: product[index].T_Unit, //4
          Quantity: product[index].T_Quantity, //5
          Productset: product[index].PRODUCTSET, //6
        };
        s.push(productArr[index]);
      }
    }
    parameter.append("listItem", JSON.stringify(s));
    var Uststus = true;
    for (var pair of parameter.entries()) {
      console.log(pair);
      if (pair[1] === "" && pair[0] === "DOCGROUP") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณาเลือกกลุ่มข้อมูล" });
        return;
      } else if (pair[1] === "" && pair[0] === "ITEMS") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณาเลือกสินค้าที่ต้องการเบิก" });
        return;
      } else if (pair[1] === "" && pair[0] === "ISSUETYPE") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณาเลือกประเภทการเบิก" });
        return;
      } else if (pair[1] === "" && pair[0] === "REMARK") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกหมายเหตุ" });
        return;
      } else if (pair[1] === "" && pair[0] === "ARCODE") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกรหัสลูกค้า" });
        return;
      } else if (pair[1] === "" && pair[0] === "ARNAME") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณาตรวจสอบชื่อลูกค้า" });
        return;
      }
    }
    if (Uststus === true) {
      this.setState({ openBackdrop: true });

      await axios
        .post(genpostURL(`CSSTKISSUEREQ/Save?`), parameter)
        .then((res) => {
          //  await axios.post(genpostURLTEST(`/Save?`), parameter).then(res => {
          if (res.data.status === "success") {
            this.setState({ opensnackbar: true });
            this.setState({ color: "success" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "บันทึกสำเร็จ" });
            setTimeout(() => {
              this.setState({ openBackdrop: false });
              this.print();
            }, 100);
          } else {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({
              messagealert: "บันทึกไม่สำเร็จ" + res.data.status,
            });
            this.setState({ openBackdrop: false });
          }
        })
        .catch((error) => {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "เกิดข้อผิดพลาด" + error });
          this.setState({ openBackdrop: false });
        });
    }
  };

  setRow = (count) => {
    var data = [];
    for (var i = 0; i <= count - 1; i++) {
      data[i] = {
        N: i + 1,
        T_Code: "",
        T_Treasury: "",
        T_Location: "",
        T_Unit: "",
        T_Quantity: "",
        T_Jobno: "",
      };
    }
    this.setState({ tableData: data });
  };
  //**************************************************************************popup**************************************************************************************/
  _setPopup = (data) => {
    switch (data) {
      case "customer":
        this.setState({
          openFullScreenDialog: true,
          titleFullScreenDialog: "ค้นหาลูกค้า",
          typeFullScreenDialog: data,
        });
        break;
      case "setdefaultwarehouse":
      case "setdefaultwarehousetable":
        this.setState({
          openFullScreenDialog: true,
          titleFullScreenDialog: "คลังสินค้า",
          typeFullScreenDialog: data,
          OtPopupType: data,
        });

        // this.setState({ OtPopupType: data })
        // this.setState({ showPopupwarehouse: !this.state.showPopupwarehouse });
        break;
      case "Searchproduct":
        this.setState({
          openFullScreenDialog: true,
          titleFullScreenDialog: "ค้นหาสินค้า",
          typeFullScreenDialog: data,
        });
        break;
      case "Groupdata":
        this.setState({
          openFullScreenDialog: true,
          titleFullScreenDialog: "กลุ่มข้อมูล",
          typeFullScreenDialog: data,
          OtPopupType: data,
        });

        // this.setState({ OtPopupType: data })
        // this.setState({ SwitchOtherPopup: !this.state.SwitchOtherPopup });
        break;

      case "Issuetype":
        this.setState({ OtPopupType: data });
        this.setState({ showPopupot: !this.state.showPopupot });
        break;
      case "Department":
        this.setState({
          OtPopupType: data,
          openFullScreenDialog: true,
          titleFullScreenDialog: "ค้นหาสินค้า",
          typeFullScreenDialog: data,
        });
        // this.setState({ SwitchOtherPopup: !this.state.SwitchOtherPopup });
        break;
      case "Branch":
        // this.setState({ OtPopupType: data })
        // this.setState({ SwitchOtherPopup: !this.state.SwitchOtherPopup });
        this.setState({
          OtPopupType: data,
          openFullScreenDialog: true,
          titleFullScreenDialog: "ค้นหาสาขา",
          typeFullScreenDialog: data,
        });
        break;
      case "Csuser":
        this.onAddValue(data, this.state.usercode);
        break;
      default:
        break;
    }
  };
  _popupClose = (data) => {
    switch (data) {
      case "customer":
        this.setState({ showPopupArcode: !this.state.showPopupArcode });
        break;
      case "Searchproduct":
        this.setState({
          openFullScreenDialog: false,
        });
        break;
      case "Groupdata":
        this.setState({ showPopupGroup: !this.state.showPopupGroup });
        break;
      case "setdefaultwarehouse":
      case "setdefaultwarehousetable":
        this.setState({ showPopupwarehouse: !this.state.showPopupwarehouse });
        break;
      case "close_PopUpOther":
        switch (this.state.OtPopupType) {
          case "Issuetype":
            this.setState({ showPopupot: !this.state.showPopupot });
            break;
          case "Department":
            this.setState({
              showPopupDepartment: !this.state.showPopupDepartment,
            });
            break;
          case "Branch":
            this.setState({ showPopupotBranch: !this.state.showPopupotBranch });
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
  };
  Get_PopUpItem = (Code, data, stockCode) => {
    console.log("Get_PopUpItem", Code);
    this.setState({ sEnableedit: false });
    this.AddDataTable(Code, this.state.row);
  };

  _getPopUparcode = (data1, data2) => {
    this.CustomerCode.current.value = data1;
    this.CustomerName.current.value = data2;
  };

  _getwarehouse = (data) => {
    console.log(data);
    var DataValue = data.split("|");
    var Pr = this.state.tableData;
    Pr[this.state.rowClick].T_Treasury = DataValue[0];
    Pr[this.state.rowClick].T_Location = DataValue[2];
    Pr[this.state.rowClick].T_Quantity = "1.00";
    // Pr[this.state.rowClick].MaxUnit = DataValue[4];
    setTimeout(() => {
      this.setState({ tableData: Pr });
    }, 50);
  };
  _getIteminPopup = (data) => {
    switch (this.state.OtPopupType) {
      case "Issuetype":
        this.Issuetype_code.current.value = this._spritData(data, "|")[0];
        this.Issuetype.current.value = this._spritData(data, "|")[1];
        this.setState({ Issuetype_txt: this._spritData(data, "|")[1] });
        break;
      case "Department":
        this.Department_code.current.value = this._spritData(data, "|")[0];
        this.Department.current.value = this._spritData(data, "|")[1];
        this.setState({ Departmentname: this._spritData(data, "|")[1] });
        break;
      case "Branch":
        this.Branch.current.value = this._spritData(data, "|")[1];
        this.Branch_code.current.value = this._spritData(data, "|")[0];
        this.setState({ Branchname: this._spritData(data, "|")[1] });
        break;
      default:
        break;
    }
  };
  _spritData(data, text) {
    var str = data.split(text);
    return str;
  }
  _cellButtonC1(cell, row, enumObject, rowIndex) {
    var btn = this.state.tableData[rowIndex].BTN_Code;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <i
            className="fas fa-search"
            style={{ cursor: "pointer", fontSize: "14px", paddingTop: "7px" }}
            onClick={(_) => this._setPopup("Searchproduct")}
            onMouseDown={(e) => {
              this.setState({ TBLastClick: row.N });
            }}
          ></i>
        );
        break;
      default:
        btnShow = <i className=""></i>;
        break;
    }
    return <div>{btnShow}</div>;
  }
  _cellButtonC3(cell, row, enumObject, rowIndex) {
    var btn = this.state.tableData[rowIndex].BTN_Treasury;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <i
            className="fas fa-search"
            style={{ cursor: "pointer", fontSize: "14px", paddingTop: "7px" }}
            onClick={this._setPopup.bind(null, "setdefaultwarehousetable")}
          ></i>
        );
        break;
      default:
        btnShow = <i className=""></i>;
        break;
    }
    return <div>{btnShow}</div>;
  }
  _cellButtonC4(cell, row, enumObject, rowIndex) {
    var btn = this.state.tableData[rowIndex].BTN_Location;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <i
            className="fas fa-search"
            style={{ cursor: "pointer", fontSize: "14px", paddingTop: "7px" }}
            onClick={this._setPopup.bind(null, "setdefaultwarehousetable")}
          ></i>
        );
        break;
      default:
        btnShow = <i className=""></i>;
        break;
    }
    return <div>{btnShow}</div>;
  }
  _chkload(cell, row, enumObject, rowIndex) {
    return (
      <div>
        <i id={"load" + rowIndex}>{rowIndex + 1}</i>
      </div>
    );
  }
  _onRowClick = (row, col, id) => {
    this.setState({ cellValue: row.T_Code });
    this.setState({ rowClick: row.N - 1 });
    var dataArray = this.state.tableData;
    var j = row.N - 1;

    // ไม่ให้คีย์ข้ามแถว
    this.setState({ col1: false });
    this.setState({ col: false });

    // จำนวนเต็มเวลาคลิก
    let T_Quantity = row.T_Quantity;
    if (col === 10 && T_Quantity !== "" && T_Quantity !== undefined) {
      row.T_Quantity = parseFloat(T_Quantity).toFixed(0);
    }

    // this._chkNulldata();
    // console.log(col);

    for (let i = 0; i < dataArray.length; i++) {
      dataArray[i].BTN_Code = 0;
      dataArray[i].BTN_Treasury = 0;
      dataArray[i].BTN_Location = 0;
      dataArray[i].btn_C5 = 0;
      dataArray[i].btn_C6 = 0;
    }

    // หาจากล่างขึ้นบน
    for (let i = this.state.tableData.length - 1; i >= 0; i--) {
      if (!this.state.tableData[i].T_Code) {
        j = i;
      }
    } //หา แถวที่ว่างบนสุดใน products Table+

    // BTN ค้นหาได้เฉพาะในแถว
    if (
      (col === 1 && j === id) ||
      (col === 1 &&
        dataArray[id].T_Code !== undefined &&
        dataArray[id].T_Code !== "")
    ) {
      this.setState({ cellname: "T_Code" });
      this.setState({ col1: true });
      dataArray[id].BTN_Code = 1;
    } else if (
      col === 4 &&
      typeof row.T_Code !== "undefined" &&
      row.T_Code !== ""
    ) {
      this.setState({ cellname: "T_Treasury" });
      this.setState({ productcodeinrow: row.T_Code });
      this.setState({ productcodeinrow1: row.T_Treasury });
      dataArray[id].BTN_Treasury = 1;
    } else if (
      col === 6 &&
      typeof row.T_Code !== "undefined" &&
      row.T_Code !== ""
    ) {
      this.setState({ productcodeinrow: row.T_Code });
      this.setState({ productcodeinrow1: row.T_Treasury });
      dataArray[id].BTN_Location = 1;
    }

    // ให้เพิ่มข้อมูลในแถวที่มีรหัสสินค้าได้
    if (typeof row.T_Code !== "undefined" && row.T_Code !== "") {
      this.setState({ col: true });
    }

    this.setState({ tableData: dataArray });
  };
  SelectSetData = (type, data) => {
    switch (type) {
      case "Calendar":
        this.setState({ withdrawaldate: data });
        break;
      case "Calendar1":
        this.setState({ scheduledreturn: data });
        break;
      case "PROJECT":
        this.setState({ PROJECT: data });
        break;
      default:
        break;
    }
  };
  AddDataTable = async (ItemCode, row) => {
    let col = this.state.tableData;
    /* รหัสสินค้าซ้ำกันเพิ่มจำนวน ปริมาณ */
    for (var i = 0; i < col.length; i++) {
      if (col[i].T_Code === ItemCode) {
        col[i].T_Quantity = parseFloat(Number(col[i].T_Quantity) + 1).toFixed(
          2
        );
        this.setState({ products: col });
        this.ReLoadData();
        return;
      }
    }
    var url =
      "CSPRODUCT/GetAllProductcode?code=" +
      ItemCode +
      "&user=" +
      localStorage.getItem("Username");
    console.log("urlCSPRODUCT ", genURL(url));
    await axios
      .get(genURL(url), { timeout: 3600 })
      .then(async (res) => {
        let data = res.data;
        var j = 0;
        if (row > -1) {
          j = row;
        } else if (this.state.TBLastClick && this.state.TBLastClick > -1) {
          j = this.state.TBLastClick - 1;
        } else {
          for (var i = this.state.products.length - 1; i >= 0; i--) {
            // หาจากล่างขึ้นบน
            if (!this.state.products[i].Productcode) {
              j = i;
            }
          }
        }
        if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            //เพิ่มขอมูลทั้งหมด ลง products Table
            var MAINGROUP = "",
              NETSTOCK = 0,
              SUBGROUP1 = "";
            console.log("PRODUCTSET", res.data[i].PRODUCTSET);
            var url1 =
              "CSPRODUCT/Code?productset=" +
              data[i].PRODUCTSET +
              "&stocktype=&code=" +
              data[i].PRODUCTCODE;
            console.log(genURL(url1));
            await axios
              .get(genURL(url1), { timeout: 3600 })
              .then(async (result) => {
                console.log(result.data);
                if (result.data.length > 0) {
                  MAINGROUP =
                    (await result.data[0].MAINGROUP) == undefined
                      ? ""
                      : result.data[0].MAINGROUP;
                  NETSTOCK = await result.data[0].NETSTOCK;
                  SUBGROUP1 = await result.data[0].SUBGROUP1;
                }
              });
            var unit = "";
            await checkunit(res.data[i].UNITCODE).then((data) => {
              unit = data;
              // console.log(unit);
            });
            // var chk = true
            // await ChkStockitem(data[i].PRODUCTCODE, "", data[i].UNITCODE, this.state.defaultwarehouse, this.state.defaultlocetion, Number(MAINGROUP)).then((res1) => {
            //     console.log(res1);
            //     if (res1 === false) {
            //         chk = false
            //     }
            // }).catch(error => {
            //     console.log(error);
            // });
            // var stock = "0.00"
            // await Checkstock(data[i].PRODUCTCODE, "", data[i].UNITCODE, this.state.defaultwarehouse, this.state.defaultlocetion, Number(MAINGROUP), String(data[i].PRODUCTSET)).then(resstock => {
            //     stock = resstock === "" ? "0.00" : parseFloat(resstock).toFixed(2);
            // }).catch(error => {
            //     console.log(error);
            // });
            col[j] = {
              N: col[j].N,
              T_Code: data[i].PRODUCTCODE,
              T_List: data[i].PRODUCTNAME,
              T_Treasury: this.state.defaultwarehouse,
              T_Location: this.state.defaultlocetion,
              T_Unit: data[i].UNITCODE,
              T_Unittxt: unit,
              T_Quantity: (0).toFixed(2),
              T_Jobno: "",
              // MaxUnit: stock,
              PRODUCTSET:
                data[i].PARENTCODE === data[0].PRODUCTCODE
                  ? "2"
                  : String(data[i].PRODUCTSET),
            };
            j++;
          }
        } else {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ไม่พบข้อมูลสินค้าในคลังสาขาของคุณ" });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    await this.setState({ tableData: col });
  };
  _getArcode = (event) => {
    var url = "";
    if (event === "CustomerCode" && this.CustomerCode.current.value !== "") {
      var arcode = this.CustomerCode.current.value;
      url =
        "CSAR/ARCode?arcode=" +
        arcode +
        "&user=" +
        localStorage.getItem("Username");
    } else if (event.key === "Enter") {
      var arcode = event.target.value.trim();
      url =
        "CSAR/ARCode?arcode=" +
        arcode +
        "&user=" +
        localStorage.getItem("Username");
    } else {
      return; //--------------- Exit เมื่อไม่เข้าเงือนไขไหนเลย
    }
    console.log(genURL(url));
    axios
      .get(genURL(url), { timeout: 3600 })
      .then((res) => {
        this.CustomerCode.current.value = "";
        this.CustomerName.current.value = "";
        if (res.data.length === 1) {
          this.CustomerCode.current.value = res.data[0].CODE;
          this.CustomerName.current.value = res.data[0].NAMETH;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  //**************************_afterSaveCell******************************** */
  _afterSaveCell = (row, cellName, cellValue) => {
    // ทศนิยม 2 ตำแหน่ง จำนวนเงิน
    var T_Quantity = row.T_Quantity;
    var T_Code = row.T_Code;
    // if (T_Code) {
    //     row.T_Quantity = parseFloat(T_Quantity).toFixed(2)
    //     if (Number(row.T_Quantity) > Number(row.MaxUnit)) {
    //         row.T_Quantity = row.MaxUnit;
    //         this.setState({ opensnackbar: true })
    //         this.setState({ color: "warning" })
    //         this.setState({ icon: ErrorIcon })
    //         this.setState({ messagealert: row.T_Code + " จำกัดสินค้า " + row.MaxUnit + " " + row.T_Unittxt })
    //     }
    // }
    var cellValue1 = this.state.cellValue;
    if (cellName === "T_Code" && cellValue !== "" && cellValue1 !== cellValue) {
      var col = this.state.tableData;
      console.log(row.N - 1);
      col[row.N - 1] = [];
      col[row.N - 1].N = row.N;
      this.setState({ tableData: col });
      this.setState({ TBLastClick: row.N });
      this.AddDataTable(cellValue, row.C0 - 1);
    } else if (cellName === "T_Code" && cellValue === "") {
      setTimeout(() => {
        this.ReLoadData();
      }, 250);
    }
  };
  ReLoadData = () => {
    var col = this.state.tableData;
    var NewCol = [],
      j = 0;
    console.log(col.length);
    for (var i = 0; i < col.length; i++) {
      if (col[i].T_Code) {
        NewCol[j] = col[i];
        j++;
      }
    }
    for (var i = j; i < col.length; i++) {
      console.log();
      NewCol[j] = { N: j + 1 };
      j++;
    }
    this.setState({ tableData: NewCol });
  };
  _chkData = (nametarget, val) => {
    if (nametarget === "Issuetype") {
      var url = "CSISSUETYPE/GETCODE?Code=" + val;
      console.log(genURL(url));
      axios
        .get(genURL(url), { timeout: 3600 })
        .then((res) => {
          let data = res.data;
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              this.Issuetype_code.current.value = data[i].CODE;
              this.Issuetype.current.value = data[i].MYNAMETH;
              this.setState({ Issuetype_txt: data[i].MYNAMETH });
            }
          } else {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "ไม่พบข้อมูล!" });
            this.Issuetype_code.current.value = "";
            this.Issuetype.current.value = "";
            this.Issuetype.current.focus();
            this.setState({ Issuetype_txt: "" });
          }
        })
        .catch((error) => {
          console.log(error);
          this.Issuetype_code.current.value = "";
          this.Issuetype.current.value = "";
          this.Issuetype.current.focus();
          this.setState({ Issuetype_txt: "" });
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ไม่สามารถโหลดข้อมูลได้!" });
        });
    }
  };
  _ResetThisPage = () => {
    window.location.replace("/CSWithdrawalrequest");
  };

  _createCustomDeleteButton = (onClick) => {
    return (
      <div style={{ marginLeft: "10px" }}>
        <i className="far fa-trash-alt" onClick={onClick}></i>
      </div>
    );
  };
  _chkDocgroup = async (code) => {
    var url = "CSDOCGROUP/Code?tablename=CSSTKISSUEREQ&code=" + code;
    console.log(genURL(url));
    await axios.get(genURL(url), { timeout: 3600 }).then((res) => {
      console.log(res.data);
      if (res.data.length > 0) {
        this.Groupdata.current.value = res.data[0].MYNAMETH;
        this.setState({ Docgroupname: res.data[0].MYNAMETH });
      } else if ((res.data.length === 0) & (code !== "")) {
        this.Groupdata.current.value = code;
        this.setState({ Docgroupname: code });
      }
    });
  };

  reCheckData = async (type, val, fix) => {
    switch (type) {
      case "Groupdata":
        CheckCodeDocGroup(val, "CSSTKISSUEREQ")
          .then((result) => {
            console.log("result Groupdata", result);
            this.Groupdata_code.current.value = val;
            this.Groupdata.current.value = result;
            this.setState({ Docgroupname: result });
          })
          .finally((_) => {
            // CheckTaxrate(val, "CSSTKISSUEREQ").then(async (result) => {
            // this.TaxPersen.current.value = await result
            // if (fix === false) {
            //   this.GenerateDocno(value, "CSSALE")
            // }
            // })
          });
        break;
    }
  };
  _reCHK = async (RowData) => {
    this.setState({
      _saveStatus: true,
      openFullScreenDialog: false,
    });
    await this.setRow(this.state.rowtb);
    var url = "CSSTKISSUEREQ/Getcodemain?code=" + RowData[0].docNo;
    console.log(genURL(url));
    await axios
      .get(genURL(url), { timeout: 3600 })
      .then(async (res) => {
        if (res.data) {
          this.setState({
            defaultvaluewarehouse:
              "รหัสคลัง: " +
              res.data[0].SITECODE +
              "  รหัสที่เก็บ: " +
              res.data[0].SITECODE +
              "001",
          });
          //
          this.setState({
            withdrawaldate: Dateconvertthai(res.data[0].DOCDATE),
            scheduledreturn: Dateconvertthai(res.data[0].DUEDATE),
            PROJECT: res.data[0].PROJECT,
          });

          this.CustomerCode.current.value = res.data[0].ARCODE;
          this.CustomerName.current.value = res.data[0].ARNAME;
          this.DeliNumber.current.value = res.data[0].DOCNO;
          this.remark.current.value = res.data[0].REMARK;
          this._chkData("Issuetype", res.data[0].ISSUETYPE);
          // this.onAddValue("Groupdata", res.data[0].DOCGROUP, "Y")
          await this.reCheckData("Groupdata", res.data[0].DOCGROUP, true);
          this.onAddValue("Department", res.data[0].DEPARTMENT);
          this.onAddValue("Branch", res.data[0].SITECODE);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    var url1 = "CSSTKISSUEREQ/Getcodesub?top=300&code=" + RowData[0].docNo;
    // console.log(genURL(url1));
    await axios
      .get(genURL(url1), { timeout: 3600 })
      .then(async (res) => {
        if (res.data.length > 0) {
          var data = this.state.tableData;
          for (var i = 0; i < res.data.length; i++) {
            var unit = "";
            await checkunit(res.data[i].UNITCODE).then((data) => {
              unit = data;
            });
            data[i].T_Code = res.data[i].PRODUCTCODE;
            data[i].T_List = res.data[i].PRODUCTNAME;
            data[i].T_Treasury = res.data[i].WAREHOUSE;
            data[i].T_Location = res.data[i].LOCATION;
            data[i].T_Unittxt = await unit;
            data[i].T_Unit = res.data[i].UNITCODE;
            data[i].T_Quantity = res.data[i].QUANTITY;
          }
          await this.setState({ tableData: data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  onSearch = (e) => {
    var data = this.state.tableData;
    for (var i = 0; i < data.length; i++) {
      data[i].T_Code = "";
      data[i].T_List = "";
      data[i].T_Treasury = "";
      data[i].T_Location = "";
      data[i].T_Unit = "";
      data[i].T_Quantity = "";
      data[i].T_Jobno = "";
      data[i].C8 = "";
      data[i].C9 = "";
      data[i].discount = "";
      data[i].C10 = "";
      this.setState({ products: data });
    }
  };
  Get_PopUpOther = async (val) => {
    var data = val.split("|");
    for (var i = 0; i < data.length; i++) {
      data[i] = data[i].trim();
    }
    switch (this.state.OtPopupType) {
      case "Groupdata":
        this.Groupdata_code.current.value = data[0];
        this.Groupdata.current.value = data[1];
        this.setState({ Groupdata_txt: data[1] });
        await Chackdocno(data[0], "CSSTKISSUEREQ")
          .then(async (result1) => {
            if (result1 !== undefined) {
              this.DeliNumber.current.value = await result1;
            } else {
              this.DeliNumber.current.value = "";
            }
          })
          .catch((err) => {
            this.DeliNumber.current.value = "";
            console.log(err);
          });
        break;
      case "Department":
        this.Department_code.current.value = await data[0];
        this.Department.current.value = await data[1];
        this.setState({ Department_txt: data[1] });
        break;
      case "Branch":
        this.Branch_code.current.value = await data[0];
        this.Branch.current.value = await data[1];
        this.setState({ Branch_txt: data[1] });
        break;
      default:
        break;
    }
  };
  onAddValue = async (type, value, Fix) => {
    console.log("sssss", type, value);
    if (type === "Groupdata") {
      Checkdocgroup(value, "CSSTKISSUEREQ")
        .then(async (result) => {
          if (result !== "") {
            this.Groupdata_code.current.value = value;
            this.Groupdata.current.value = result;
            this.setState({ Groupdata_txt: result });
          } else {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "ไม่พบข้อมูล!" });
            this.Groupdata_code.current.value = "";
            this.Groupdata.current.value = "";
            this.setState({ Groupdata_txt: "" });
          }
        })
        .catch((err) => {
          this.Groupdata_code.current.value = "";
          this.Groupdata.current.value = "";
          this.setState({ Groupdata_txt: "" });
          console.log(err);
        });
      if (Fix !== "Y") {
        await Chackdocno(value, "CSSTKISSUEREQ")
          .then((result1) => {
            if (result1 !== "") {
              this.DeliNumber.current.value = result1;
            } else {
              this.DeliNumber.current.value = "";
            }
          })
          .catch((err) => {
            this.DeliNumber.current.value = "";
            console.log(err);
          });
      }
    }
    if (type === "CustomerCode") {
      await ChackAr(value)
        .then((result) => {
          console.log(result);
          if (result !== "") {
            let data = result.split("|");
            this.CustomerCode.current.value = value;
            this.CustomerName.current.value = data[0];
          } else {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "ไม่พบข้อมูล!" });
            this.CustomerCode.current.value = "";
            this.CustomerName.current.value = "";
          }
        })
        .catch((err) => {
          this.CustomerCode.current.value = "";
          this.CustomerName.current.value = "";
          console.log(err);
        });
    }
    if (type === "Csuser") {
      console.log("sssssxxxxxx");
      await CheckUser(value)
        .then(async (result) => {
          console.log("sssss", result);
          if (result !== "") {
            this.Csuser_code.current.value = await value;
            this.Csuser.current.value = await result;
          } else {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "ไม่พบข้อมูล!" });
            this.Csuser_code.current.value = "";
            this.Csuser.current.value = "";
          }
        })
        .catch((err) => {
          this.Csuser_code.current.value = "";
          this.Csuser.current.value = "";
          console.log(err);
        });
    }
    if (type === "Department") {
      await CheckDepartmentname(value)
        .then((result) => {
          console.log(result);
          if (result !== "") {
            this.Department_code.current.value = value;
            this.Department.current.value = result;
            this.setState({ Department_txt: result });
          } else {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "ไม่พบข้อมูล!" });
            this.Department_code.current.value = "";
            this.Department.current.value = "";
            this.setState({ Department_txt: "" });
          }
        })
        .catch((err) => {
          this.Department_code.current.value = "";
          this.Department.current.value = "";
          this.setState({ Department_txt: "" });
          console.log(err);
        });
    }
    if (type === "Branch") {
      await CheckBrabchname(value)
        .then((result) => {
          if (result !== "") {
            this.Branch_code.current.value = value;
            this.Branch.current.value = result;
            this.setState({ Branch_txt: result });
          } else {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "ไม่พบข้อมูล!" });
            this.Branch_code.current.value = "";
            this.Branch.current.value = "";
            this.setState({ Branch_txt: "" });
          }
        })
        .catch((err) => {
          this.Branch_code.current.value = "";
          this.Branch.current.value = "";
          this.setState({ Branch_txt: "" });
          console.log(err);
        });
    }
  };
  Switch_OtherPopup = (type) => {
    this.setState({ OtPopupType: type });
    this.setState({ SwitchOtherPopup: !this.state.SwitchOtherPopup });
  };
  onClick = (e) => {
    if (e.target.value !== "") {
      switch (e.target.name) {
        case "Groupdata":
          this.Groupdata.current.value = this.Groupdata_code.current.value;
          break;
        case "Issuetype":
          this.Issuetype.current.value = this.Issuetype_code.current.value;
          break;
        case "Department":
          this.Department.current.value = this.Department_code.current.value;
          break;
        case "Branch":
          this.Branch.current.value = this.Branch_code.current.value;
          break;
        default:
          break;
      }
    }
  };
  onKeyDown = (e) => {
    if (e.key === "Enter") {
      if (e.target.name === "Groupdata") {
        this.onAddValue("Groupdata", e.target.value);
      }
      if (e.target.name === "CustomerCode") {
        this.onAddValue("CustomerCode", e.target.value);
      }
      if (e.target.name === "Issuetype") {
        this._chkData("Issuetype", e.target.value);
      }
      if (e.target.name === "Department") {
        this.onAddValue("Department", e.target.value);
      }
      if (e.target.name === "Branch") {
        this.onAddValue("Branch", e.target.value);
      }
    }
  };
  onChange = (e) => {
    switch (e.target.name) {
      case "Groupdata":
        if (e.target.value === "") {
          this.setState({ Groupdata_txt: "" });
          this.Groupdata_code.current.value = "";
          this.DeliNumber.current.value = "";
        }
        break;
      case "CustomerCode":
        if (e.target.value === "") {
          this.CustomerCode.current.value = "";
          this.CustomerName.current.value = "";
        }
        break;
      case "Issuetype":
        if (this.Issuetype.current.value === "") {
          this.setState({ Issuetype_txt: "" });
          this.Issuetype_code.current.value = "";
        }
        break;
      case "Department":
        if (e.target.value === "") {
          this.setState({ Department_txt: "" });
          this.state.Department_txt = "";
        }
        break;
      case "Branch":
        if (e.target.value === "") {
          this.setState({ Branch_txt: "" });
          this.Branch_code.current.value = "";
        }
        break;
      default:
        break;
    }
  };
  onBlur = (e) => {
    if (e.target.name === "Groupdata") {
      this.Groupdata.current.value = this.state.Groupdata_txt;
    }
    if (e.target.name === "Issuetype") {
      this.Issuetype.current.value = this.state.Issuetype_txt;
    }
    if (e.target.name === "Department") {
      this.Department.current.value = this.state.Department_txt;
    }
    if (e.target.name === "Branch") {
      this.Branch.current.value = this.state.Branch_txt;
    }
  };
  onClickTopbar = (e) => {
    console.log(e);
    switch (e) {
      case "save":
        this._onSave();
        break;
      case "new":
        this._ResetThisPage();
        break;
      case "print":
        console.log("print");
        this.print();
        break;
      case "search":
        this.onSearch();
        // this.setState({ SwitchSearchDoc: true });
        this.setState({
          titleFullScreenDialog: "ค้นหาใบขอเบิก",
          typeFullScreenDialog: "SearchDoc",
          openFullScreenDialog: true,
        });
        break;

      default:
        break;
    }
  };
  CloseDialog = (e) => {
    this.setState({ openFullScreenDialog: e });
  };
  ReportCloseDialog = (e) => {
    this.setState({ openFullScreenDialog: e });
    setTimeout(() => {
      this._ResetThisPage();
    }, 1000);
  };

  print = async () => {
    // check mid is null
    if (
      this.state.mid === null ||
      typeof this.state.mid === "undefined" ||
      this.state.mid === ""
    ) {
      await this.checkMID();
    }

    if (
      this.DeliNumber.current.value === "" ||
      this.DeliNumber.current.value === null ||
      typeof this.DeliNumber.current.value === "undefined"
    ) {
      await this.setState({
        opensnackbar: true,
        messagealert: "กรุณากรอกเลขที่เอกสาร",
        color: "warning",
      });
      return;
    } else if (
      this.state.mid === null ||
      typeof this.state.mid === "undefined" ||
      this.state.mid === ""
    ) {
      await this.setState({
        opensnackbar: true,
        color: "warning",
        messagealert: "mid ไม่ถูกต้องกรุณาเลือกเมนูใหม่อีกครั้ง",
      });
    } else {
      await this.setState({
        titleFullScreenDialog: "พิมพ์เอกสาร",
        typeFullScreenDialog: "print",
        openFullScreenDialog: true,
      });
    }
  };
  propsvalue = (data) => {
    console.log(data);
    if (data.source === "CSWAREHOUSEALL") {
      this.setState({ defaultwarehouse: data.warehouse });
      this.setState({ defaultlocetion: data.location });
    }
  };

  render() {
    const options = {
      onRowClick: this._onRowClick,
      deleteBtn: this._createCustomDeleteButton,
    };
    const selectRow = {
      mode: "checkbox",
    };
    return (
      <div
        className="PSApp"
        onClick={this.onClick}
        onKeyDown={this.onKeyDown}
        onChange={this.onChange}
        onBlur={this.onBlur}
      >
        <Backdrop open={this.state.openBackdrop} />
        <FullScreenDialog
          open={this.state.openFullScreenDialog}
          title={this.state.titleFullScreenDialog}
          closeDialog={(e) => this.CloseDialog(e)}
        >
          {this.state.typeFullScreenDialog === "SearchDoc" ? (
            <Rechecked
              Dataselect={(e) => this._reCHK(e)}
              from="CSSTKISSUEREQ"
            />
          ) : this.state.typeFullScreenDialog === "Searchproduct" ? (
            <PopUpItem
              closePopup={(e) => this.CloseDialog(e)}
              Get_PopUpItem={this.Get_PopUpItem}
              from="CSSTKISSUEREQ"
            />
          ) : this.state.typeFullScreenDialog === "customer" ? (
            <PopupArcode
              closePopup={(e) => this.CloseDialog(e)}
              Get_PopUparcode={this._getPopUparcode}
            />
          ) : this.state.typeFullScreenDialog === "setdefaultwarehouse" ||
            this.state.typeFullScreenDialog === "setdefaultwarehousetable" ? (
            <_PopUpwarehouse
              closePopup={(e) => this.CloseDialog(e)}
              type={this.state.OtPopupType}
              Get_PopUpOther={this._getwarehouse}
              productcodeinrow={this.state.productcodeinrow}
              productcodeinrow1={this.state.productcodeinrow1}
              from="CSSTKISSUEREQ"
            />
          ) : this.state.typeFullScreenDialog === "print" ? (
            <PDFReportDialog
              closePopup={(e) => this.ReportCloseDialog(e)}
              mid={this.state.mid}
              docNo={this.DeliNumber.current.value}
            />
          ) : (
            <PopUpOther
              closePopup={(e) => this.CloseDialog(e)}
              type={this.state.OtPopupType}
              Get_PopUpOther={this.Get_PopUpOther}
              userSite={this.state.siteCodeUser}
              from="CSSTKISSUEREQ"
            />
          )}
        </FullScreenDialog>
        {/* {this.state.showPopupproduct ? <PopUpItem closePopup={this._popupClose.bind(null, "product")} Get_PopUpItem={this.Get_PopUpItem} userSite={"11"} from="CSSTKISSUEREQ" /> : null} */}
        {/* {this.state.showPopupArcode ? <PopupArcode closePopup={this._popupClose.bind(null, "customer")} Get_PopUparcode={this._getPopUparcode} /> : null} */}
        {/* {this.state.SwitchOtherPopup ? <PopUpOther closePopup={this.Switch_OtherPopup} type={this.state.OtPopupType} Get_PopUpOther={this.Get_PopUpOther} userSite={this.state.siteCodeUser} from="CSSTKISSUEREQ" /> : null} */}
        {this.state.showPopupwarehouse ? (
          <_PopUpwarehouse
            closePopup={this._popupClose.bind(null, "setdefaultwarehouse")}
            type={this.state.OtPopupType}
            Get_PopUpOther={this._getwarehouse}
            productcodeinrow={this.state.productcodeinrow}
            productcodeinrow1={this.state.productcodeinrow1}
            from="CSSTKISSUEREQ"
          />
        ) : null}
        {this.state.showPopupot ? (
          <PopUpOther1
            closePopup={this._popupClose.bind(null, "close_PopUpOther")}
            type={this.state.OtPopupType}
            Get_PopUpOther={this._getIteminPopup}
          />
        ) : null}
        {/* {this.state.SwitchSearchDoc ? <PopUpSearchDoc closePopup={() => { this.setState({ SwitchSearchDoc: !this.state.SwitchSearchDoc }) }} Get_Popup={this._reCHK} from="CSSTKISSUEREQ" userSite={this.state.siteCodeUser} /> : null} */}
        <div /* className="displaymain" */>
          <Topbar
            listmenu={listmenu}
            title="บันทึกใบขอเบิกสินค้า/วัตถุดิบ"
            onClick={(e) => this.onClickTopbar(e)}
          />
          <div className="PSAppfrom">
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                <MaterialUIPickers
                  title="วันที่ขอเบิก"
                  DateValue={(e) => this.SelectSetData("Calendar", e)}
                  defaultdate={this.state.withdrawaldate}
                  open={this.state.checkenableInput["DOCDATE"]}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon"> กลุ่มข้อมูล </span>
                    <input type="hidden" ref={this.Groupdata_code} />
                    <input
                      id="2"
                      type="text"
                      className="form-control"
                      name="Groupdata"
                      ref={this.Groupdata}
                    />
                    <span className="input-group-addon textIcon">
                      <i>
                        {" "}
                        <ArrowDropDownRoundedIcon
                          fontSize="small"
                          onClick={this._setPopup.bind(null, "Groupdata")}
                        />
                      </i>
                      {/*   <i className="fas fa-search" ></i> */}
                    </span>
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon">เลขที่ใบขอเบิก </span>
                    <input
                      id="3"
                      name="DeliNumber"
                      type="text"
                      className="form-control"
                      tabIndex="2"
                      ref={this.DeliNumber}
                      readOnly
                    />
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                <MaterialUIPickers
                  title="กำหนดคืน"
                  DateValue={(e) => this.SelectSetData("Calendar1", e)}
                  defaultdate={this.state.scheduledreturn}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon"> ประเภทการเบิก </span>
                    <input type="hidden" ref={this.Issuetype_code} />
                    <input
                      id="5"
                      type="text"
                      className="form-control"
                      name="Issuetype"
                      ref={this.Issuetype}
                    />
                    <span
                      className="input-group-addon textIcon"
                      onClick={this._setPopup.bind(null, "Issuetype")}
                    >
                      <i>
                        {" "}
                        <ArrowDropDownRoundedIcon fontSize="small" />
                      </i>
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon"> ผู้ขอเบิก </span>
                    <input
                      type="text"
                      className="form-control hidden"
                      ref={this.Csuser_code}
                    />
                    <input
                      type="text"
                      className="form-control"
                      ref={this.Csuser}
                      disabled
                    />
                    <span className="input-group-addon textIcon">
                      <i>
                        {" "}
                        <AutorenewIcon
                          fontSize="small"
                          onClick={this._setPopup.bind(null, "Csuser")}
                        />
                      </i>
                    </span>
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon">เบิกให้ลูกค้า </span>
                    <input
                      id="6"
                      type="text"
                      className="form-control col-md-6"
                      name="CustomerCode"
                      ref={this.CustomerCode}
                    />
                    <span className="input-group-addon textIcon">
                      <i>
                        {" "}
                        <ArrowDropDownRoundedIcon
                          fontSize="small"
                          onClick={this._setPopup.bind(null, "customer")}
                        />
                      </i>
                      {/* <i className="fas fa-search" onClick={}></i> */}
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span
                      id="iconCustomerName"
                      className="input-group-addon icon"
                    >
                      <i className="fas fa-user"></i>
                    </span>
                    <input
                      id="7"
                      type="text"
                      className="form-control col-md-6"
                      name="CustomerName"
                      ref={this.CustomerName}
                    />
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon"> หมายเหตุ </span>
                    <input
                      id="8"
                      type="text"
                      className="form-control"
                      name="remark"
                      ref={this.remark}
                    />
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <CustomInputtext
                  title="คลังเริ่มต้น"
                  value={this.state.defaultvaluewarehouse}
                  disabledvalue={true}
                  of_title={false}
                  of_btn={false}
                  source={"CSWAREHOUSEALL"}
                  propsvalue={this.propsvalue}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BootstrapTable
                  data={this.state.tableData}
                  // cellEdit={cellEditProp}
                  cellEdit={{
                    mode: "click",
                    blurToSave: true,
                    beforeSaveCell: this.onBeforeSaveCell,
                    afterSaveCell: this._afterSaveCell,
                  }}
                  options={options}
                  height="400"
                  headerStyle={{ borderBottom: "#BFBCBB  1px solid" }}
                >
                  <TableHeaderColumn
                    row="0"
                    rowSpan="2"
                    dataField="N"
                    width="20"
                    isKey
                    dataAlign="center"
                    dataFormat={this._chkload.bind(this)}
                  ></TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    colSpan="2"
                    dataField=""
                    headerAlign="center"
                    className="colbuttomhidden"
                    width="120"
                  >
                    รหัสสินค้า
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="1"
                    dataField="T_Code"
                    headerAlign="center"
                    width="90"
                    editable={this.state.col1}
                  >
                    {" "}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="1"
                    dataField="BTN_Code"
                    dataAlign="center"
                    width="30"
                    columnClassName="c_btn"
                    editable={false}
                    dataFormat={this._cellButtonC1.bind(this)}
                  >
                    {" "}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    rowSpan="2"
                    dataField="T_List"
                    editable={false}
                    width="130"
                    dataAlign="left"
                  >
                    ชื่อสินค้า
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    colSpan="2"
                    dataField=""
                    headerAlign="center"
                    className="colbuttomhidden"
                  >
                    คลัง
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="1"
                    dataField="T_Treasury"
                    editable={this.state.col}
                    width="90"
                    dataAlign="center"
                  ></TableHeaderColumn>
                  <TableHeaderColumn
                    row="1"
                    dataField="BTN_Treasury"
                    dataAlign="center"
                    width="30"
                    columnClassName="c_btn"
                    editable={false}
                    dataFormat={this._cellButtonC3.bind(this)}
                  >
                    {" "}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    colSpan="2"
                    dataField=""
                    headerAlign="center"
                    className="colbuttomhidden"
                  >
                    ตำแหน่งเก็บ
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="1"
                    dataField="T_Location"
                    editable={this.state.col}
                    width="90"
                    dataAlign="center"
                  ></TableHeaderColumn>
                  <TableHeaderColumn
                    row="1"
                    dataField="BTN_Location"
                    dataAlign="center"
                    width="30"
                    columnClassName="c_btn"
                    editable={false}
                    dataFormat={this._cellButtonC4.bind(this)}
                  >
                    {" "}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    colSpan="2"
                    dataField=""
                    headerAlign="center"
                    width="60"
                    className="colbuttomhidden"
                  >
                    หน่วย
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="1"
                    dataField="T_Unittxt"
                    editable={false}
                    width="60"
                    dataAlign="center"
                  ></TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    dataField="T_Unit"
                    editable={false}
                    width="60"
                    dataAlign="center"
                    hidden
                  ></TableHeaderColumn>
                  <TableHeaderColumn
                    row="1"
                    dataField="C5_show"
                    dataAlign="center"
                    width="60"
                    columnClassName="c_btn"
                    editable={false}
                  >
                    {" "}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    rowSpan="2"
                    dataField="T_Quantity"
                    width="80"
                    dataAlign="center"
                    editable={this.state.col}
                  >
                    ปริมาณ
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    dataField="T_Jobno"
                    editable
                    width="80"
                    dataAlign="center"
                    hidden
                  >
                    Jobno
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    dataField="C5_insert"
                    editable
                    width="80"
                    dataAlign="center"
                    hidden
                  ></TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    dataField="PRODUCTSET"
                    width="90"
                    editable={false}
                    hidden
                  >
                    PRODUCTSET
                  </TableHeaderColumn>
                </BootstrapTable>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon">แผนก </span>
                    <input type="text" ref={this.Department_code} hidden />
                    <input
                      id="9"
                      type="text"
                      className="form-control"
                      name="Department"
                      ref={this.Department}
                    />
                    <span
                      className="input-group-addon textIcon"
                      onClick={this._setPopup.bind(null, "Department")}
                    >
                      <i>
                        {" "}
                        <ArrowDropDownRoundedIcon fontSize="small" />
                      </i>
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <SelectDatas
                      origin="PROJECT" // โครงการ
                      valueSelect={(e) => this.SelectSetData("PROJECT", e)} // รับค่ากลับ
                      title="โครงการ"
                      defaultselect={this.state.PROJECT} // ค่าเริ่มต้นของ โครงการ
                    />
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon">สาขา </span>
                    <input type="hidden" ref={this.Branch_code} />
                    <input
                      id="10"
                      type="text"
                      className="form-control"
                      name="Branch"
                      ref={this.Branch}
                    />
                    <span
                      className="input-group-addon textIcon"
                      onClick={this._setPopup.bind(null, "Branch")}
                    >
                      <i>
                        {" "}
                        <ArrowDropDownRoundedIcon fontSize="small" />
                      </i>
                    </span>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
          <Snackbar
            place="br"
            color={this.state.color}
            icon={this.state.icon}
            autoClose={this.state.autoClose}
            message={this.state.messagealert}
            open={this.state.opensnackbar}
            closeNotification={() => {
              this.setState({ opensnackbar: false });
            }}
            close
          />
        </div>
      </div>
    );
  }
}
